import { formatNumber, formatDecimal } from '@/features/reports/lib/format';
import { fa } from '../i18n/fa';

export default function KpiStrip({ kpis, sources = [], onSeveritySelect }) {
  const severityCodes = Object.keys(fa.severity);
  const totalSources = kpis.sources_total;
  const availableSources = kpis.sources_ok;
  const unavailableCount = Math.max(0, totalSources - availableSources);
  const unavailableSources = sources.filter((source) => !source.ok).map((source) => fa.sourceName(source.name));
  const sourcesTone = totalSources === 0
    ? 'slate'
    : unavailableCount === 0
      ? 'green'
      : unavailableCount > totalSources / 2
        ? 'red'
        : 'amber';
  const sourcesIcon = sourcesTone === 'green'
    ? 'fa-circle-check'
    : sourcesTone === 'slate'
      ? 'fa-database'
      : 'fa-triangle-exclamation';
  const unavailableTitle = unavailableSources.length > 0
    ? fa.kpis.unavailableSources(unavailableSources.join('، '))
    : undefined;
  const items = [
    { label: fa.kpis.chains, value: formatNumber(kpis.chains), tone: 'green', icon: 'fa-link' },
    {
      label: fa.kpis.critical,
      value: formatNumber(kpis.critical),
      tone: 'red',
      icon: 'fa-triangle-exclamation',
      severity: severityCodes[0],
    },
    {
      label: fa.kpis.warning,
      value: formatNumber(kpis.warning),
      tone: 'amber',
      icon: 'fa-bell',
      severity: severityCodes[1],
    },
    { label: fa.kpis.hoarding, value: formatNumber(kpis.hoarding_suspects), tone: 'teal', icon: 'fa-warehouse' },
    { label: fa.kpis.coverage, value: `${formatDecimal(kpis.avg_coverage, 1)}٪`, tone: 'blue', icon: 'fa-circle-check' },
    {
      label: fa.kpis.sources,
      value: totalSources === 0
        ? '—'
        : <bdi dir="rtl">{formatNumber(availableSources)} از {formatNumber(totalSources)}</bdi>,
      tone: sourcesTone,
      icon: sourcesIcon,
      subline: unavailableCount > 0 ? fa.kpis.sourcesUnavailable(unavailableCount) : null,
      title: unavailableTitle,
      ariaLabel: totalSources === 0
        ? `${fa.kpis.sources}: —`
        : `${formatNumber(availableSources)} از ${formatNumber(totalSources)}، ${fa.kpis.sources}${unavailableCount > 0 ? `، ${fa.kpis.sourcesUnavailable(unavailableCount)}` : ''}`,
    },
  ];
  return (
    <div className="tr-kpis">
      {items.map(({ label, value, tone, icon, subline, title, ariaLabel, severity }) => {
        const contents = (
          <>
            <i className={`fas ${icon} tr-kpi-ic`} aria-hidden="true" />
            <b>{value}</b>
            <span>{label}</span>
            {subline && <span className="tr-kpi-subline">{subline}</span>}
          </>
        );
        const className = `tr-kpi tr-kpi-${tone}${label === fa.kpis.sources ? ' tr-kpi-sources' : ''}`;
        if (severity && onSeveritySelect) {
          return (
            <button
              className={`${className} tr-kpi-button`}
              key={label}
              type="button"
              onClick={() => onSeveritySelect(severity)}
            >
              {contents}
            </button>
          );
        }
        return (
          <div
            className={className}
            key={label}
            title={title}
            aria-label={ariaLabel}
            role={title ? 'group' : undefined}
            tabIndex={title ? 0 : undefined}
          >
            {contents}
          </div>
        );
      })}
    </div>
  );
}
